/**
 * Платёжные блоки, которым цену даёт «Выбор тарифа»: своя цена ЛИБО тариф
 * селектора (Ревизия десятки 7 + хвост Н-16 + WEB-1398; stripe_checkout_form —
 * старая форма оплаты, платит тем же путём, что button_to_pay и
 * stripe_wallets_express).
 *
 * ЕДИНСТВЕННЫЙ перечень группы на фронте: им ветвится лестница цены живой
 * страницы (`resolvePriceId.ts`) и проверка публикации редактора
 * (`components/editor/pricingGate.ts` берёт этот же массив и отдаёт дальше).
 * Канон на сервере — `SELECTOR_FALLBACK_BLOCK_TYPES` в
 * `backend/src/paywalls/utils/pricing-gate.util.ts`; совпадение множеств
 * судит `backend/src/paywalls/utils/pricing-gate-fe-mirror.web1302.spec.ts`.
 *
 * WEB-3336, вес первого экрана: перечень вынесен из гейта редактора, чтобы
 * живая страница не тянула гейт в кусок первого экрана. Модулю — только
 * импорты типов (держит `__tests__/selectorFallbackBlockTypes.web3336.test.ts`).
 */
import type { EditorBlock } from '@/store/editorSlice';

export const SELECTOR_FALLBACK_BLOCK_TYPES: readonly EditorBlock['type'][] = [
  'button_to_pay',
  'stripe_wallets_express',
  'stripe_checkout_form',
];
